module.exports = __webpack_public_path__ + "static/12-f10f6f7acc848e51502fa779220730bb.jpg";